import request from 'superagent';
import tree from '../state';
import config from '../config';

export function getHomePage() {
    // console.log("homeService -> getHomePage()");
    return request.get(`${config.apiBase}/api/home`)
        .set('authorization', tree.get('token'))
        .then(res => JSON.parse(res.text));
}




// WEBPACK FOOTER //
// ./src/services/homeService.js